import { makeStyles } from "@mui/styles";

const styles = makeStyles(theme => ({
  mainHeader: {
    color: theme.palette.secondary.main
  },
  logoWidth: {
    width: "100px",
  },
  qrWidth: {
    width: "120px"
  }
}));
export default styles;